module.exports = __webpack_public_path__ + "img/atmbersama.4b6947f4.png";